const isLocal = () => {
  return process.env.NODE_ENV === "local";
};

const isStaging = () => {
  return process.env.NODE_ENV === "development";
};

const isProduction = () => {
  return process.env.NODE_ENV === "production";
};

const getCurrentEnv = () => {
  return process.env.NODE_ENV;
};

export default { isLocal, isStaging, isProduction, getCurrentEnv };
